import { P2TextDescription, P2Accordion } from 'react-bootstrap-common-script';
import { Separator } from '../../../components/separator';
import { CalendarIcon, ClockSvg, MapPinIcon } from '../../../assets/svg';
import { useAppSelector } from '../../../redux/hook';
import { useGetCpfWithdrawalOverviewQuery } from '../../../redux/services/getStageE';
import { Helpers } from '../../../utils/helper';
import { useCallback, useState } from 'react';

interface DateTimeLocationProps {
  index?: number;
}

const DateTimeLocation: React.FC<DateTimeLocationProps> = ({ index }) => {
  const [isAccordionActive, setIsAccordionActive] = useState<boolean>(true);

  // Toggle the accordion subtitle when called.
  const handleAccordionSubtitle = useCallback(() => {
    setIsAccordionActive((prev) => !prev);
  }, []);

  const queryParameters = new URLSearchParams(window.location.search);
  const application_id = queryParameters.get('application_id');
  const loginUser = useAppSelector((state) => state.auth.AuthenticationSlice.loginUser);
  const singpassToken = useAppSelector((state) => state.auth.AuthenticationSlice.singpassToken);

  const { data: cpfWithdrawalOverview } = useGetCpfWithdrawalOverviewQuery({
    application_id: application_id ?? '',
    uinfin: loginUser.uinfin ?? '',
    singpass_token: singpassToken ?? '',
  });

  return (
    <div className='polymer-stage-e-accordion'>
      <P2Accordion
        defaultOpen={true}
        hasDivider={true}
        onToggle={handleAccordionSubtitle}
        title={
          <div className={`polymer-accordion-listing_title ${isAccordionActive ? 'accordion-active' : ''}`}>
            <h4>{index}. Date, time and location</h4>

            {isAccordionActive && (
              <div className='polymer-stage-e-accordion-subtitle'>
                <P2TextDescription color='#333' description={'All applicants must attend the completion appointment in person.'} />
              </div>
            )}
          </div>
        }>
        {/* Accordion's Content Starts Here --- */}
        {/* appointmentDate is only populated once HDB has fixed the actual appointment;
            until then, show a pending state instead of any date or branch. While the
            query is still loading (or errored), render nothing rather than claiming
            the appointment is unconfirmed. */}
        {!cpfWithdrawalOverview ? null : !cpfWithdrawalOverview.appointmentDate ? (
          <div style={{ margin: '24px 0 0 0' }}>
            <P2TextDescription
              size='18px'
              color='#333'
              description_margin='0px'
              description='Your completion appointment date and time will be confirmed by HDB. We will notify you once the appointment is scheduled.'
            />
          </div>
        ) : (
        <>
        <div className='d-flex flex-column flex-sm-row align-items-start justify-content-sm-between gap-2' style={{ margin: '24px 0 0 0' }}>
          <div className='d-flex flex-row justify-content-sm-center align-items-center' style={{ gap: '9px' }}>
            <CalendarIcon />
            <P2TextDescription
              size='18px'
              color='#333'
              description_margin='0px'
              description={`${Helpers.getDayOfWeek(cpfWithdrawalOverview?.appointmentDate ?? '')}, ${Helpers.formatDate(
                cpfWithdrawalOverview?.appointmentDate ?? ''
              )}`}
            />
          </div>
          <div className='d-flex flex-row justify-content-sm-center align-items-center' style={{ gap: '9px' }}>
            <ClockSvg />
            <P2TextDescription
              size=''
              color='#333'
              description_margin='0px'
              description={Helpers.formatAppointmentStartTime(cpfWithdrawalOverview?.appointmentTime)}
            />
          </div>
        </div>

        <Separator variant='dashed' style={{ margin: '24px 0' }} />
        <div className='d-flex justify-content-start align-items-center' style={{ gap: '9px' }}>
          <div style={{ height: '24px', width: '24px' }}>
            <MapPinIcon />
          </div>
          <div>
            <P2TextDescription
              size='18px'
              color='#333'
              description_margin='0'
              description={Helpers.formatTitleCase(cpfWithdrawalOverview?.branchName ?? '')}
            />
            <P2TextDescription
              size='18px'
              color='#333'
              description_margin='0'
              description={Helpers.formatTitleCase(cpfWithdrawalOverview?.branchAddress ?? '')}
            />
          </div>
        </div>
        </>
        )}
      </P2Accordion>
    </div>
  );
};

export default DateTimeLocation;
